module.exports = __webpack_public_path__ + "img/img619.74d90689.png";